// import ActionType from 'actions/ActionType'
// import { omit } from 'lodash'

export default (state = {}, action) => {
  switch (action.type) {
    // case ActionType.Inbox.SEND_SMS:
    //   if (
    //     action.payload &&
    //     // !action.payload.contactSelected &&
    //     action.payload.contact_id
    //   ) {
    //     const {
    //       last_interaction,
    //       contact_id,
    //       contact,
    //       to,
    //       from_number,
    //       text,
    //       length,
    //     } = action.payload

    //     const newConversationItem = {
    //       newConversationItem: true,
    //       timestamp: last_interaction,
    //       type: 'sms',
    //       direction: 'outbound',
    //       sms: {
    //         recipient_id: contact_id,
    //         recipient_number: to,
    //         originator_id: '_system',
    //         originator_number: from_number,
    //         body: text,
    //       },
    //     }

    //     const newConversation =
    //       state[contact_id] && state[contact_id].newConversation
    //         ? [...state[contact_id].newConversation, newConversationItem]
    //         : [newConversationItem]

    //     return {
    //       ...state,
    //       [contact_id]: {
    //         contact_id,
    //         contact,
    //         last_interaction,
    //         currentLength: length,
    //         newConversation,
    //       },
    //     }
    //   }
    //   return state
    // case ActionType.Email.SEND_REQUEST:
    //   if (
    //     action.extraData &&
    //     // !action.extraData.contactSelected &&
    //     action.payload &&
    //     action.payload.email_messages &&
    //     action.payload.email_messages[0]
    //   ) {
    //     const { last_interaction, contact_id, length, contact } = action.extraData
    //     const email = action.payload.email_messages[0]

    //     const newConversationItem = {
    //       newConversationItem: true,
    //       timestamp: last_interaction,
    //       type: 'email',
    //       direction: 'thread',
    //       thread: {
    //         last_interaction,
    //         emails: [
    //           {
    //             timestamp: last_interaction,
    //             direction: 'outbound',
    //             from: 'no-reply@vasttechnologies.com',
    //             from_id: contact_id,
    //             to: email.to || '',
    //             subject: email.subject || '',
    //             full_email_uri: '',
    //             preview_text: email.body || '',
    //           },
    //         ],
    //       },
    //     }

    //     const newConversation =
    //       state[contact_id] && state[contact_id].newConversation
    //         ? [...state[contact_id].newConversation, newConversationItem]
    //         : [newConversationItem]

    //     return {
    //       ...state,
    //       [contact_id]: {
    //         last_interaction,
    //         contact_id,
    //         contact,
    //         currentLength: length,
    //         newConversation,
    //       },
    //     }
    //   }
    //   return state
    // case ActionType.Data.READ_SUCCESS:
    //   if (action.entityType === 'inbox') {
    //     if (
    //       action.payload &&
    //       action.payload.contact_id &&
    //       action.payload.conversation &&
    //       state[action.payload.contact_id]
    //     ) {
    //       const currentLength = action.payload.conversation.length
    //       const slice =
    //         currentLength - state[action.payload.contact_id].currentLength
    //       const newConversation = state[
    //         action.payload.contact_id
    //       ].newConversation.slice(slice)

    //       if (newConversation.length) {
    //         return {
    //           ...state,
    //           [action.payload.contact_id]: {
    //             currentLength,
    //             newConversation,
    //           },
    //         }
    //       } else {
    //         return omit(state, action.payload.contact_id)
    //       }
    //     }
    //     return state
    //   }
    //   return state
    default:
      return state
  }
}
